<template>
    <div :class="[
             dualLine ? 'info-bar--dual-line' : ''
         ]" 
         class="info-bar">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'info-bar',
    components: {},
    props: {
        dualLine: Boolean
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.info-bar
    padding: 10px 40px
    margin: -20px -40px 20px -40px
    border-bottom: 1px solid $light-border-color
    display: flex

    .info-bar-column
        padding: 0px 20px
        margin: 0px 0px
        flex-grow: 1
        font-size: 14px
        border-right: 1px solid $light-border-color
        position: relative

        h5, span.title
            font-weight: bold
            margin: 5px 5px 5px 0px
            display: inline-block

        &:first-child
            padding-left: 0
            margin-left: 0

        &:last-child
            padding-right: 0
            margin-right: 0
            border-right-width: 0

    &.info-bar--dual-line
        span.title
            display: block

    @media screen and (max-width: 1280px)
        span.title
            display: block !important

    @media screen and (max-width: 1024px)
        margin: -20px -20px 20px -20px

    @media screen and (max-width: 480px)
        display: grid
        grid-template-columns: 1fr 1fr
        overflow: auto
        border-bottom-width: 0px !important
        margin: 0 0 20px 0
        padding: 10px 20px

        .info-bar-column
            border-bottom: 1px solid $light-border-color
            border-right-width: 0
            padding: 0 10px 10px
            margin: 0px 0 10px
            float: left
            word-break: break-all

            &:first-child
                padding: 0 10px 10px
</style>
